<template>
  <div class="row">
    <div class="col-xl-12">
      <router-view />

      <div
        v-show="$route.path == '/Report/AgentScoreEvaluation'"
        class="kt-portlet kt-portlet--mobile"
        style="min-width: 2500px !important;"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ปีงบประมาณ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'searchYear'"
                    :name="'searchYear'"
                    :select2-options="yearOptions"
                    v-model="searchYear"
                    ref="yearSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <treeselect
                    v-model="searchAgentCode"
                    :multiple="true"
                    :options="searchAgentOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-5 col-lg-8 col-md-8 col-sm-6 col-xs-12 d-flex align-items-end">
                <div class="form-group">
                  <!-- <button type="button" class="btn btn-primary" @click="loadAgentScore">
                    Generate Report
                  </button> -->
                  <button
                    type="button"
                    class="btn btn-outline-primary ml-2"
                    @click="exportData"
                  >
                    <i class="fas fa-file-export"></i> Export Excel
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12" style="max-height: calc(100vh - 260px); overflow: auto;">
                <table class="table table-sm table-bordered" id="agentScoreReport">
                  <thead>
                    <tr>
                      <th scope="col" rowspan="2" class="TH">NO</th>
                      <th scope="col" rowspan="2" class="TH">ปี</th>
                      <th scope="col" rowspan="2" class="TH">รหัส</th>
                      <th scope="col" rowspan="2" class="TH">ชื่อตัวแทนจำหน่าย</th>
                      <th scope="col" colspan="12" class="TH THMAC">คะแนนถังคงค้าง</th>
                      <th scope="col" colspan="12" class="TH THSYS">คะแนนการทำระบบเบียร์สด</th>
                      <th scope="col" colspan="13" class="TH THTOT">รวมคะแนน</th>
                    </tr>
                    <tr>
                      <th scope="col" class="TH THMAC">ม.ค.</th>
                      <th scope="col" class="TH THMAC">ก.พ.</th>
                      <th scope="col" class="TH THMAC">มี.ค.</th>
                      <th scope="col" class="TH THMAC">เม.ย.</th>
                      <th scope="col" class="TH THMAC">พ.ค.</th>
                      <th scope="col" class="TH THMAC">มิ.ย.</th>
                      <th scope="col" class="TH THMAC">ก.ค.</th>
                      <th scope="col" class="TH THMAC">ส.ค.</th>
                      <th scope="col" class="TH THMAC">ก.ย.</th>
                      <th scope="col" class="TH THMAC">ต.ค.</th>
                      <th scope="col" class="TH THMAC">พ.ย.</th>
                      <th scope="col" class="TH THMAC">ธ.ค.</th>

                      <th scope="col" class="TH THSYS">ม.ค.</th>
                      <th scope="col" class="TH THSYS">ก.พ.</th>
                      <th scope="col" class="TH THSYS">มี.ค.</th>
                      <th scope="col" class="TH THSYS">เม.ย.</th>
                      <th scope="col" class="TH THSYS">พ.ค.</th>
                      <th scope="col" class="TH THSYS">มิ.ย.</th>
                      <th scope="col" class="TH THSYS">ก.ค.</th>
                      <th scope="col" class="TH THSYS">ส.ค.</th>
                      <th scope="col" class="TH THSYS">ก.ย.</th>
                      <th scope="col" class="TH THSYS">ต.ค.</th>
                      <th scope="col" class="TH THSYS">พ.ย.</th>
                      <th scope="col" class="TH THSYS">ธ.ค.</th>

                      <th scope="col" class="TH THTOT">ม.ค.</th>
                      <th scope="col" class="TH THTOT">ก.พ.</th>
                      <th scope="col" class="TH THTOT">มี.ค.</th>
                      <th scope="col" class="TH THTOT">เม.ย.</th>
                      <th scope="col" class="TH THTOT">พ.ค.</th>
                      <th scope="col" class="TH THTOT">มิ.ย.</th>
                      <th scope="col" class="TH THTOT">ก.ค.</th>
                      <th scope="col" class="TH THTOT">ส.ค.</th>
                      <th scope="col" class="TH THTOT">ก.ย.</th>
                      <th scope="col" class="TH THTOT">ต.ค.</th>
                      <th scope="col" class="TH THTOT">พ.ย.</th>
                      <th scope="col" class="TH THTOT">ธ.ค.</th>

                      <th scope="col" class="TH">Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-if="dataSource.length === 0">
                      <td colspan="41" class="text-center">
                        <h6>ไม่พบข้อมูลที่อนุมัติแล้ว</h6>
                      </td>
                    </tr>
                    <template v-for="(item, i) in dataSource">
                      <tr>
                        <td class="text-center align-middle TITLE">{{ i + 1 }}</td>
                        <td class="text-center align-middle TITLE">{{ item.year }}</td>
                        <td class="text-center align-middle TITLE">{{ item.agentCode }}</td>
                        <td class="text-left align-middle" style="min-width:250px !important;">{{ item.agentName }}</td>

                        <td class="text-center align-middle MAC">{{ (item.maC_JAN != null) ? item.maC_JAN : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_FEB != null) ? item.maC_FEB : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_MAR != null) ? item.maC_MAR : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_APR != null) ? item.maC_APR : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_MAY != null) ? item.maC_MAY : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_JUN != null) ? item.maC_JUN : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_JUL != null) ? item.maC_JUL : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_AUG != null) ? item.maC_AUG : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_SEP != null) ? item.maC_SEP : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_OCT != null) ? item.maC_OCT : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_NOV != null) ? item.maC_NOV : '-' }}</td>
                        <td class="text-center align-middle MAC">{{ (item.maC_DEC != null) ? item.maC_DEC : '-' }}</td>

                        <td class="text-center align-middle SYS">{{ (item.syS_JAN != null) ? item.syS_JAN : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_FEB != null) ? item.syS_FEB : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_MAR != null) ? item.syS_MAR : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_APR != null) ? item.syS_APR : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_MAY != null) ? item.syS_MAY : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_JUN != null) ? item.syS_JUN : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_JUL != null) ? item.syS_JUL : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_AUG != null) ? item.syS_AUG : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_SEP != null) ? item.syS_SEP : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_OCT != null) ? item.syS_OCT : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_NOV != null) ? item.syS_NOV : '-' }}</td>
                        <td class="text-center align-middle SYS">{{ (item.syS_DEC != null) ? item.syS_DEC : '-' }}</td>

                        <td class="text-center align-middle TOT">{{ (item.totaL_JAN != null) ? item.totaL_JAN : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_FEB != null) ? item.totaL_FEB : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_MAR != null) ? item.totaL_MAR : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_APR != null) ? item.totaL_APR : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_MAY != null) ? item.totaL_MAY : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_JUN != null) ? item.totaL_JUN : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_JUL != null) ? item.totaL_JUL : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_AUG != null) ? item.totaL_AUG : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_SEP != null) ? item.totaL_SEP : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_OCT != null) ? item.totaL_OCT : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_NOV != null) ? item.totaL_NOV : '-' }}</td>
                        <td class="text-center align-middle TOT">{{ (item.totaL_DEC != null) ? item.totaL_DEC : '-' }}</td>

                        <td class="text-center align-middle TOT">{{ item.grandTotal }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#agentScoreReport .TH {
  background: #ccc !important;
  text-align: center !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  font-family: Noto Sans Thai UI;
  vertical-align: middle !important;
}
#agentScoreReport .THMAC {
  background: #C6E7FF !important;
}
#agentScoreReport .THSYS {
  background: #FFE8CD !important;
}
#agentScoreReport .THTOT {
  background: #C9C9C9 !important;
}
#agentScoreReport .TITLE {
  font-size: 14px !important;
}
#agentScoreReport tbody td,
#agentScoreReport tbody td a {
  font-size: 14px !important;
}
#agentScoreReport .MAC {
  background: #E8F9FF !important;
}
#agentScoreReport .SYS {
  background: #F8F2E5 !important;
}
#agentScoreReport .TOT {
  background: #EEEEEE !important;
}
#agentScoreReport.table-bordered th,
#agentScoreReport.table-bordered td {
  border: 1px solid #c2c2c2 !important;
}
/* Freeze header row เมื่อ scroll ลง */
#agentScoreReport {
  border-collapse: separate !important;
  border-spacing: 0;
}
#agentScoreReport thead th {
  position: sticky !important;
  top: 0;
  z-index: 10;
  background-clip: padding-box;
}
#agentScoreReport thead tr:nth-child(1) th {
  top: 0;
}
#agentScoreReport thead tr:nth-child(2) th {
  top: 40px;
}
#agentScore thead tr:nth-child(1) th {
    top: 0;
    height: 50px;
    padding: 6px 8px;
}

/* row 2 */
#agentScore thead tr:nth-child(2) th {
    top: 50px;
    padding: 6px 8px;
    height: 50px;
}
</style>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    const currentYear = new Date().getFullYear();
    const yearData = [
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      { id: currentYear.toString(), text: currentYear.toString() },
      { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() },
      { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() },
      { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() },
      { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() },
    ];

    return {
      searchYear: currentYear.toString(),
      searchAgentCode: [],
      searchAgentOptions: [],
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: yearData,
      },
      dataSource: [],
    };
  },
  methods: {
    loadAgentOptions() {
      var self = this;
      axios
        .post("/Api/AgentScore/AgentScoreDashboardAgentList", {})
        .then(function (response) {
          if (response.status == 200 && Array.isArray(response.data)) {
            response.data.forEach((element) => {
              self.searchAgentOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) {});
    },
    loadAgentScore() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่...",
      });

      var params = {
        StatusCode: "APPROVE",
      };
      if (self.searchYear) {
        params.Year = self.searchYear;
      }
      if (self.searchAgentCode && self.searchAgentCode.length > 0) {
        params.AgentCodeSap = self.searchAgentCode;
      }

      try {
        axios({
          method: "post",
          url: "/Api/AgentScore/AgentScoreEvalation",
          data: params,
        })
          .then(function (response) {
            self.dataSource = response.data;
          })
          .catch(function (error) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              error.response.data.message,
              "error"
            ).then(function () {});
          })
          .then(function () {
            KTApp.unblockPage();
          });
      } catch (error) {
        console.error("Error load score data:", error);
      }
    },
    exportData: function () {
      var self = this;

      if (!self.searchYear) {
        Swal.fire("แจ้งเตือน", "กรุณาเลือกปีงบประมาณ", "warning");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/AgentScore/ExportEvaluationData",
        responseType: "arraybuffer",
        data: {
          Year: self.searchYear,
          StatusCode: "APPROVE",
          AgentCodeSap: (self.searchAgentCode && self.searchAgentCode.length > 0) ? self.searchAgentCode : null,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            //link.download = decodeURIComponent(filename);
             link.download =
             moment().format("YYYY-MM-DD") +"_รายงานประเมินตัวแทนจำหน่ายเบียร์สด"+
            ".xlsx";
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลที่อนุมัติแล้วตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่อนุมัติแล้ว", "error");
        })
        .then(function () {
          KTApp.unblockPage();
        });
    },
  },
  mounted() {
    let self = this;
    this.loadAgentOptions();
    this.loadAgentScore();

    this.$nextTick();
    const currentYear = new Date().getFullYear();
    $("#searchYear").val(currentYear.toString()).trigger("change");
  },
  watch: {
    searchYear: function (newVal, oldVal) {
      this.loadAgentScore();
    },
    searchAgentCode: function (newVal, oldVal) {
      this.loadAgentScore();
    },
  },
};
</script>

<style lang="scss">
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// App/Components/Report/AgentScoreEvaluationReport.vue